import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';
import PageLoading from './components/PageLoading';

const NotFound = React.lazy(() => import('./pages/NotFound'));

const About = React.lazy(() => import('./pages/About'));
const AboutAddEdit = React.lazy(() => import('./pages/AboutAddEdit'));
const Contact = React.lazy(() => import('./pages/Contact'));
const ContactAddEdit = React.lazy(() => import('./pages/ContactAddEdit'));
const MainSlider = React.lazy(() => import('./pages/MainSlider'));
const MainSliderAddEdit = React.lazy(() => import('./pages/MainSliderAddEdit'));
const Testimonials = React.lazy(() => import('./pages/Testimonials'));
const TestimonialAddEdit = React.lazy(() => import('./pages/TestimonialAddEdit'));
const Gallery = React.lazy(() => import('./pages/Gallery'));
const GalleryAddEdit = React.lazy(() => import('./pages/GalleryAddEdit'));
const Privacy = React.lazy(() => import('./pages/Privacy'));
const PrivacyAddEdit = React.lazy(() => import('./pages/PrivacyAddEdit'));
const TermsServices = React.lazy(() => import('./pages/TermsServices'));
const TermsServicesAddEdit = React.lazy(() => import('./pages/TermsServicesAddEdit'));
const Faq = React.lazy(() => import('./pages/Faq'));
const FaqAddEdit = React.lazy(() => import('./pages/FaqAddEdit'));
const Setting = React.lazy(() => import('./pages/Setting'));
const SettingAddEdit = React.lazy(() => import('./pages/SettingAddEdit'));

function Router() {
	const routes = [
		{
			path: '/about',
			module: <About />,
		},
		{
			path: '/about/add',
			module: <AboutAddEdit />,
		},
		{
			path: '/about/edit/:editAboutId',
			module: <AboutAddEdit />,
		},

		{
			path: '*',
			module: <NotFound />,
		},

		{
			path: '/contact',
			module: <Contact />,
		},
		{
			path: '/contact/add',
			module: <ContactAddEdit />,
		},
		{
			path: '/contact/edit/:editContactId',
			module: <ContactAddEdit />,
		},
		{
			path: '/main-slider',
			module: <MainSlider />,
		},
		{
			path: '/main-slider/add',
			module: <MainSliderAddEdit />,
		},
		{
			path: '/main-slider/edit/:editSliderId',
			module: <MainSliderAddEdit />,
		},
		{
			path: '/testimonials',
			module: <Testimonials />,
		},
		{
			path: '/testimonials/add',
			module: <TestimonialAddEdit />,
		},
		{
			path: '/testimonials/edit/:editTestimonialId',
			module: <TestimonialAddEdit />,
		},
		{
			path: '/gallery',
			module: <Gallery />,
		},
		{
			path: '/gallery/add',
			module: <GalleryAddEdit />,
		},
		{
			path: '/gallery/edit/:editGalleryId',
			module: <GalleryAddEdit />,
		},
		{
			path: '/privacy',
			module: <Privacy />,
		},
		{
			path: '/privacy/add',
			module: <PrivacyAddEdit />,
		},
		{
			path: '/privacy/edit/:editPrivacyId',
			module: <PrivacyAddEdit />,
		},
		{
			path: '/terms-services',
			module: <TermsServices />,
		},
		{
			path: '/terms-services/add',
			module: <TermsServicesAddEdit />,
		},
		{
			path: '/terms-services/edit/:editTermsId',
			module: <TermsServicesAddEdit />,
		},
		{
			path: '/faq',
			module: <Faq />,
		},
		{
			path: '/faq/add',
			module: <FaqAddEdit />,
		},
		{
			path: '/faq/edit/:editFaqId',
			module: <FaqAddEdit />,
		},
		{
			path: '/settings',
			module: <Setting />,
		},
		{
			path: '/settings/add',
			module: <SettingAddEdit />,
		},
		{
			path: '/settings/edit/:editSettingId',
			module: <SettingAddEdit />,
		},
	];

	return (
		<Layout.Content
			style={{
				margin: '0 16px',
				background: '#F2F2F2',
			}}
		>
			<Routes>
				{routes.map((item, i) => (
					<Route key={i} path={item.path} element={<React.Suspense fallback={<PageLoading />}>{item.module}</React.Suspense>} />
				))}
			</Routes>
		</Layout.Content>
	);
}

export default Router;
